const CHANGE_TICKETDATA = "CHANGE_TICKETDATA";
const CLONE_TICKET = "CLONE_TICKET";

const initState = {
    ticketData: {},
    isClone: false
}

export const cloneTicket = (bool) =>{
    return {
        payload: bool,
        type:CLONE_TICKET
    }
}

export const ticketData = (money) =>{
    return {
        payload: money,
        type:CHANGE_TICKETDATA
    }   
}

const Reducer = (state = initState,action) =>{
    // console.log(action.payload)
    switch(action.type){
        case CHANGE_TICKETDATA:
            return {...state,
                ticketData:action.payload
            }
        case CLONE_TICKET:
            return {...state,
                isClone:action.payload
            }
        default:
            return state;
    }
}

export default Reducer;